import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/Reveal";
import { IMG } from "@/data/site";

const milestones = [
  { year: "The Vision", text: "It began with a conviction held by CEO Khalid Abdulkhakim Salama: Tanzanian hospitality deserved a stage as beautiful as its people. The name came first — Zuri Sana, 'very beautiful' in Swahili." },
  { year: "The Group", text: "Zuri Sana Hospitality Group took shape around one promise — African Luxury, World-Class Hospitality — growing to two properties: the Golden Pigeon Hotel in Mwanza and Zuri Sana Hotel in Zanzibar." },
  { year: "The Island Home", text: "In Zanzibar, garden bungalows with makuti-thatched roofs rose steps from the beach — a hotel that feels unmistakably of its island: barefoot, warm and beautifully kept." },
  { year: "Today", text: "Today, Zuri Sana welcomes guests from across East Africa and the world — pursuing its vision to be the leading destination for luxury hospitality in Africa. Karibu sana." },
];

export default function OurStory() {
  return (
    <div data-testid="our-story-page">
      <PageHero overline="Our Story" title="Born of a beautiful idea" subtitle="How a Swahili word for beauty became an island home for travellers." image={IMG.beachView} />
      <section className="py-24 md:py-32 max-w-4xl mx-auto px-6 md:px-12">
        {milestones.map((m, i) => (
          <FadeUp key={m.year} delay={i * 0.05}>
            <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 py-12 border-t hairline">
              <p className="md:col-span-4 font-serif-display text-3xl font-light text-[#d4af37]">{m.year}</p>
              <p className="md:col-span-8 text-[#a3a3a3] leading-relaxed">{m.text}</p>
            </div>
          </FadeUp>
        ))}
      </section>
    </div>
  );
}
